<template>
  <div class="order-details-drawer-wrapper">
    <div class="order-details-drawer-title">
      Pedido {{ order.orderId }}
    </div>
    <div class="order-details-drawer-details">
      <checkout-info :order="order" :products="products" :user="user"/>
    </div>
  </div>
</template>

<script>
import CheckoutInfo from './CheckoutInfo.vue';

export default {
  components: {
    CheckoutInfo,
  },
  props: {
    order: {
      type: Object,
    },
    products: {
      type: Array,
    },
    user: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.order-details-drawer-title {
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  color: #212B36;
}
.order-details-drawer-details {
  display: grid;
  grid-template-columns: 50% 50%;
  margin-top: 26px;
  margin-bottom: 20px;
}
.order-details-drawer-details-title {
  font-size: 14px;
  line-height: 20px;
  color: #212B36;
  margin-bottom: 8px;
}
.order-details-drawer-details-value {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #212B36;
}
@media (max-width: $sm) {
  .order-details-drawer-wrapper {
    width: unquote("Calc(100vw - 48px) !important");
  }
  .order-details-drawer-title {
    margin-left: 55px;
    margin-top: 5px;
  }
  .order-details-drawer-details {
    display: block;
    margin-top: 26px;
    margin-bottom: 20px;
  }
}
</style>
